import { register } from "@antv/xflow"
import { AllCustomCells } from "./custom-cells"

AllCustomCells.forEach((item) => {
  register(item);
})